<template>
	<section class="container__body container__body--md">

		<section class="col-12 margin-b-50">

			<a href="#" class="btn btn--sm btn--secondary secondary--grey" @click.prevent="showCreateModal = true">Opret gruppe</a>

		</section>

		<draggable v-model="extraSelections">

			<transition-group name="fade">

				<section class="data-list margin-b-100" v-for="selection in extraSelections" :key="selection.id">

					<header class="col-12 margin-b-50 settings">

						<h1 v-text="selection.title"></h1>

						<ws-dropdown>

							<template slot="thumb">	<i class="fas fa-cog icon--sm dark-grey"></i></template>

							<template slot="content">

								<ul>
									<li><a href="#" @click.prevent="showEditSelectionModal(selection)"><i class="fas fa-pencil-alt"></i> Rediger</a></li>
									<li><a href="#" @click.prevent="showDeleteSelectionModal(selection)"><i class="fas fa-trash-alt"></i> Slet</a></li>
								</ul>

							</template>

						</ws-dropdown>

					</header>

					<section class="item" v-for="option in selection.options">

						<section class="icon">

							<i class="icon--lg fas fa-shopping-bag"></i>

						</section>

						<section class="content">

							<h1 v-text="option.title"></h1>

							<ul>
								<li>Status: Aktiv</li>
								<li>Pris: {{stripeAmount(option.price).amount}},-</li>
							</ul>

						</section>

						<section class="link">

							<a href="product-stats" @click.prevent="removeOption(selection, option)">Fjern</a>

						</section>

					</section>

					<section class="item--add padding-tb-50" @click.prevent="openAddOptionModal(selection)">

						<section class="icon">

							<i class="fas fa-plus-circle"></i>

						</section>

						<section class="content">

							<h2>Tilføj tilvalg</h2>

						</section>

					</section>

				</section>

				<section class="data-list" v-if="extraSelections.length == 0" key="notfound">

					<h4>Ingen grupper fundet</h4>

				</section>

			</transition-group>

		</draggable>

		<section class="col-12 margin-t-75">

			<button class="btn btn--md btn--primary primary--copper" @click.prevent="updateOptions" :disabled="isSaving">

				<span v-if="isSaving"><i class="spinner--light"></i> Gemmer</span>

				<span v-else>Gem og fortsæt</span>

			</button>

		</section>

		<ws-modal v-model="showOptionListModal">

			<section class="modal-wrap--search">

				<section class="modal--sm">

					<span class="close" @click.prevent="showOptionListModal = false"><i class="fas fa-times"></i></span>

					<options-list @selected="addOption" :selection-options="currentExtraSelectionOptionsById" v-if="currentExtraSelection"></options-list>

				</section>

			</section>

		</ws-modal>

        <ws-modal v-model="showCreateModal">

            <section class="modal-wrap">

                <section class="modal--sm">

                    <h1 class="margin-b-100">Opret gruppe</h1>

                    <span class="close" @click.prevent="showCreateModal = false"><i class="fas fa-times"></i></span>

                    <extra-selection-form @completed="selectionCreated"></extra-selection-form>

                </section>

            </section>

        </ws-modal>

		<ws-modal v-model="showEditModal">

			<section class="modal-wrap">

				<section class="modal--sm">

					<h1 class="margin-b-100">Rediger gruppe</h1>

					<span class="close" @click.prevent="showEditModal = false"><i class="fas fa-times"></i></span>

					<extra-selection-form @completed="selectionUpdated" :selection="currentExtraSelection"></extra-selection-form>

				</section>

			</section>

		</ws-modal>

		<ws-modal v-model="showDeleteModal">

			<section class="modal-wrap">

				<section class="modal--sm center" v-if="currentExtraSelection">

					<span class="close" @click.prevent="showDeleteModal = false"><i class="fas fa-times"></i></span>

					<i class="fas fa-trash-alt icon--lg margin-b-25"></i>

					<h1>Slet gruppe?</h1>

					<h2>Er du sikker på du vil slette {{currentExtraSelection.title}}?</h2>

					<h3>Du kan ikke fortryde denne handling!</h3>

					<section class="col-12 margin-t-25">

						<a class="btn btn--sm btn--primary primary--copper" href="#" @click.prevent="deleteSelection">Ja tak</a>

						<a href="#" @click.prevent="showDeleteModal = false">Nej tak!</a>

					</section>

				</section>

			</section>

		</ws-modal>

	</section>
</template>

<script>
    import {mapGetters} from 'vuex';
	import ExtraSelectionForm from './components/extraSelectionForm.vue';
    import OptionsList from './components/optionsList.vue';
    export default {
        name: "extra",
		data(){
          	return {
          	    extraSelections:[],
                showOptionListModal:false,
                showCreateModal:false,
                showEditModal:false,
                showDeleteModal:false,
                currentExtraSelection:null,
                isSaving:false,
			}
		},
		components:{
            ExtraSelectionForm,
            OptionsList
		},
		computed:{
            ...mapGetters({
                product:'product'
            }),
            currentExtraSelectionOptionsById(){
                if(!this.currentExtraSelection){
                    return null;
                }
                return this.currentExtraSelection.options.map(item=>{
                    return item.id;
                });
            }
		},
        watch:{
            product(value){
                if(value !== null){
                    this.getExtraSelections();
                }
            }
        },
		methods:{
            getExtraSelections(){
                axios.get(`/api/admin/product/${this.product.id}/extra/selection`).then(response => {
                    this.extraSelections = response.data.data;
                });
            },
			updateExtraSelectionsArray(data){
                if(data.hasOwnProperty('isUpdating')){
                    const selection = this.extraSelections.find((item)=>{
                        return item.id == data.id;
                    });
                    selection.title = data.title;
                    selection.min_options = data.min_options;
                    return;
                }

                if(data.hasOwnProperty('isDeleting')){
                    this.extraSelections = this.extraSelections.filter((item)=>{
                        return item.id !== data.id;
                    });

                    return;
                }

                this.extraSelections.push(data);
			},
            openAddOptionModal(selection){
                this.showOptionListModal = true;
                this.currentExtraSelection = selection;
            },
            addOption(option){
                this.currentExtraSelection.options.push(option);
                this.showOptionListModal = false;
                this.currentExtraSelection = null;
            },
            removeOption(selection, option){
                selection.options = selection.options.filter(item =>{
                    return item !== option;
                })
            },
            updateOptions(){
                if(this.isSaving){
                    return;
                }

                this.isSaving = true;
                axios.put(`/api/admin/product/${this.product.id}/extra/selection/batch`, {
                    extra_selections: this.extraSelections.map(item => {
                        return {
                            extra_selection_id: item.id,
                            options: item.options.map(option => {
                                return option.id;
                            }),
                        };
                    }),
                    orders: this.extraSelections.map((item, index) => {
                        return {
                            extra_selection_id: item.id,
                            order: index + 1,
                        }
                    }),
                }).then(response => {
                    this.isSaving = false;
                    this.$router.replace({
                        name:'product.edit.approve',
                    });
                });
            },
            showEditSelectionModal(selection){
                this.currentExtraSelection = selection;
                this.showEditModal = true;
            },
            showDeleteSelectionModal(selection){
                this.currentExtraSelection = selection;
                this.showDeleteModal = true;
            },
            selectionCreated(data){
                this.showCreateModal = false;
                this.updateExtraSelectionsArray(data);
            },
            selectionUpdated(data){
                this.showEditModal = false;
                this.updateExtraSelectionsArray(data);
                this.currentExtraSelection = null;
            },
            deleteSelection(selection){
                axios.delete(`/api/admin/product/${this.product.id}/extra/selection/${this.currentExtraSelection.id}`).then(response=>{
                    this.showDeleteModal = false;
                    selection = this.currentExtraSelection;
                    selection.isDeleting = true;
                    this.updateExtraSelectionsArray(selection);
                    this.currentExtraSelection = null;
                });
            }
		},
        beforeRouteEnter(to, from, next){
            next(vm=>{
                vm.$store.dispatch('getProduct', vm.$route.params.product);
            })
        },
    }
</script>

<style scoped>

</style>
